import React from "react";
import CssClasses from "./RightSectionTicket.css";
import Ticket from "../../Components/Ticket/Ticket";

const RightSectionTicket = props => {
  return (
    <div className={CssClasses.container}>
      <Ticket />
    </div>
  );
};

export default RightSectionTicket;



// WEBPACK FOOTER //
// ./src/Containers/RightSectionTicket/RightSectionTicket.js